/** @format */
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
Vue.use(VueCompositionApi)

// ** -----------------------------------------------------------------------
// todo Get sale-invoice lines total total
let correctedTotal
let roundingAmount
let creditTag
let freeTag
let documentTypeTag
const invoiceVatRateOrder = [25, 12, 6, 0]
const taxableVatRates = [25, 12, 6]

const getInvoiceVatAmount = (documentData, item) => {
	return documentData.invoice_type === 'Inland'
		? item.vat_credit
		: item.vat_credit_exchange
}

const getPaperInvoiceFeeVatPercent = (documentData) => {
	return documentData.paper_invoice_fee_vat_percent !== null &&
		documentData.paper_invoice_fee_vat_percent !== undefined
		? documentData.paper_invoice_fee_vat_percent
		: 25
}

const getInvoiceVatSummary = (documentData, documentLines) => {
	const vatBuckets = {}
	const vatRatesInInvoice = []
	const invoicesLinesVatArr = documentLines.map((item) => [
		item.vat_percent,
		getInvoiceVatAmount(documentData, item),
	])
	const addVatToBucket = (vatPercent, vatAmount) => {
		if (vatPercent === null || vatPercent === undefined) {
			return
		}
		const vatRate = Number(vatPercent)
		if (!invoiceVatRateOrder.includes(vatRate)) {
			return
		}
		if (!vatRatesInInvoice.includes(vatRate)) {
			vatRatesInInvoice.push(vatRate)
		}
		vatBuckets[vatRate] = (vatBuckets[vatRate] || 0) + (vatAmount || 0)
	}
	invoicesLinesVatArr.forEach((item) => {
		addVatToBucket(item[0], item[1])
	})
	if (documentData.is_fee_addable === true) {
		addVatToBucket(
			getPaperInvoiceFeeVatPercent(documentData),
			documentData.paper_invoice_fee_vat,
		)
	}
	const invoiceVatArr = invoiceVatRateOrder
		.filter((vatRate) => vatRatesInInvoice.includes(vatRate))
		.map((vatRate) => ({
			vat: `${vatRate}%`,
			vatAmount: vatBuckets[vatRate] || 0,
		}))
	if (invoiceVatArr.length === 0) {
		invoiceVatArr.push({ vat: '0%', vatAmount: 0 })
	}
	return {
		invoicesLinesVatArr,
		invoiceVatArr,
	}
}

const calculateToPay = (documentData, documentLines, docType = 'invoice') => {
	if (docType === 'reminder') {
		console.log('useCalculateToPayFunctions documentData', documentData)
		const correctedTotal = parseInt(
			documentData.reminder_lines._reminder_headers
				.reminder_headers_reminder_lines_rel_aggregate.aggregate.sum
				.invoice_balance / 100,
		)
		return { correctedTotal }
	} else {
		console.log('calculateToPay documentLines', documentLines)
		console.log('calculateToPay documentData', documentData)
		const documentLanguage = documentData.invoice_language
		// const exc = documentData.invoice_exchange_unit
		const invoiceType = documentData.invoice_type
		// ? lines total total
		const invoicesLinesTotalArr = documentLines.map((item) =>
			documentData.invoice_type === 'Inland'
				? item.line_price_total_credit
				: item.line_price_total_credit_exchange,
		)
		if (documentData.is_fee_addable === true) {
			invoicesLinesTotalArr.push(documentData.paper_invoice_fee)
		}
		console.log('invoicesLinesTotalArr', invoicesLinesTotalArr)
		// todo ----------------------------------------------------------
		const getInvoiceSubTotal = invoicesLinesTotalArr.reduce(function (
			result,
			item,
		) {
			return result + item
		},
		0)
		console.log('sales sale-invoice subtotal', getInvoiceSubTotal)
		// todo ----------------------------------------------------------------------------
		// ? Get lines vat total
		// ************** sale-invoice type göre exc
		const invoicesLinesVatTotalArr = documentLines.map((item) =>
			documentData.invoice_type === 'Inland'
				? item.vat_credit
				: item.vat_credit_exchange,
		)
		if (documentData.is_fee_addable === true) {
			invoicesLinesVatTotalArr.push(documentData.paper_invoice_fee_vat)
		}
		console.log('invoicesLinesVatTotalArr', invoicesLinesVatTotalArr)
		// ----------------------------------------------------------
		const getSumVat = invoicesLinesVatTotalArr.reduce(function (result, item) {
			return result + item
		}, 0)
		console.log('sales sale-invoice getSumVat', getSumVat)
		// todo ----------------------------------------------------------------------------
		// ? TO PAY
		let toPay = (getSumVat + getInvoiceSubTotal) / 100
		console.log('TO PAY', toPay)
		let rounding = toPay - parseInt(toPay)
		if (rounding < 0.5) {
			correctedTotal = parseInt(toPay)
			roundingAmount = -1 * rounding
		} else {
			correctedTotal = parseInt(toPay) + 1
			roundingAmount = 1 - rounding
		}
		// todo ----------------------------------------------------------------------------
		// ? Get sale-invoice vat array
		const { invoicesLinesVatArr, invoiceVatArr } = getInvoiceVatSummary(
			documentData,
			documentLines,
		)
		console.log(
			'************* ======>>>>> invoicesLinesVatArr',
			invoicesLinesVatArr,
		)
		console.log('invoiceVatArr', invoiceVatArr)
		// todo ----------------------------------------------------------------------------
		// ? Get invoice_price
		const getInvoicePrice = (item) => {
			return documentData.invoice_type === 'Inland'
				? item.invoice_price
				: item.invoice_price_exchange
		}
		// todo ----------------------------------------------------------------------------
		// ? Get line_price_total_credit
		const getLinePriceTotalCredit = (item) => {
			return documentData.invoice_type === 'Inland'
				? item.line_price_total_credit
				: item.line_price_total_credit_exchange
		}
		// todo ----------------------------------------------------------------------
		// ? Get creditTag
		const getCreditTag = () => {
			switch (documentLanguage) {
				case 'en':
					return toPay < 0 ? 'Credit ' : ''
				default:
					return toPay < 0 ? 'Kredit ' : ''
			}
		}
		creditTag = getCreditTag()
		// todo --------------------------------------------------------------------------
		// ? get momsfri tag
		let result
		const getVatFreeTag = () => {
			switch (invoiceType) {
				case 'Inland':
					for (let i = 0; i < invoicesLinesVatArr.length; i++) {
						if (taxableVatRates.includes(Number(invoicesLinesVatArr[i][0]))) {
							result = ''
							break
						} else {
							result = 'Momsfri '
						}
					}
					return result
				default:
					return documentLanguage === 'se' ? 'Momsfri ' : 'VAT-free '
			}
		}
		freeTag = getVatFreeTag()
		// todo --------------------------------------------------------------------------
		const getDocumentTypeTag = () => {
			switch (invoiceType) {
				case 'Inland':
					return ''
				default:
					return documentLanguage === 'se' ? 'Utländsk ' : 'Overseas '
			}
		}
		documentTypeTag = getDocumentTypeTag()
		return {
			creditTag, // *
			freeTag, // *
			documentTypeTag, // *
			getInvoiceSubTotal, // *?
			toPay,
			correctedTotal, // *?
			roundingAmount, // *?
			invoiceVatArr, // *?
			getInvoicePrice,
			getLinePriceTotalCredit,
		}
	}
	// todo --------------------------------------------------------------------------
}

export default function useCalculateToPayFunctions() {
	return {
		calculateToPay,
	}
}
